import React from "react";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomChartsTitle,
  CustomTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { Grid, Box, Card, Container } from "@mui/material";
import CustomTransactionTable from "../../components/Custom/CustomTransactionTable";

const DecarbonizationBuyer = () => {
  const { t } = useTranslation();
  const columns = [
    { label: "Farmer Name", field: "farmerName" },
    { label: "Credits", field: "credits" },
    { label: "Program", field: "program" },
    { label: "Action", field: "action" },
  ];

  const data = [
    {
      farmerName: "Kisan Patil",
      credits: "300",
      program: "Stubble",
      action: "-",
    },
    {
      farmerName: "Dewrat Singh",
      credits: "270",
      program: "Stubble",
      action: "-",
    },
    {
      farmerName: "Madhur Patle",
      credits: "73",
      program: "Stubble",
      action: "-",
    },
  ];

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <CustomTitle>{t("Decarbonization")}</CustomTitle>
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Box sx={{ marginTop: "20px" }}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <CustomDashboardCard title={t("My Programs")} data={"7"} />
                </Grid>
                <Grid item xs={4}>
                  <CustomDashboardCard title={t("All Programs")} data={"31"} />
                </Grid>
                <Grid item xs={4}>
                  <CustomDashboardCard
                    title={t("Carbon Ledger")}
                    data={"9000"}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Sponsor Details")}</CustomChartsTitle>
              <Grid container spacing={1} sx={{ padding: "10px 0" }}>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("New Farmers 51")}</CustomValue>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("Total Sponsored 11")}</CustomValue>
                  </Card>
                </Grid>
              </Grid>
            </Box>

            <Box>
              <Grid item xs={12} height="150px">
                <CustomTransactionTable columns={columns} data={data} />
              </Grid>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default DecarbonizationBuyer;
